import { SVGProps, Ref, forwardRef } from 'react';

export const CubeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M1.783 3.609 8 6.717l6.217-3.108L8 .5z" fill="currentColor" />
            <path d="m15 4.783-6.3 3.15V15.5l6.3-3.15z" fill="currentColor" />
            <path d="M7.3 15.5V7.933L1 4.783v7.567z" fill="currentColor" />
        </g>
    </svg>
));
CubeFilledSize16Glyph.displayName = 'CubeFilledSize16Glyph';
